import React from 'react';
import Navbar from '../components/Navbar';
import './Information.css';

const Information = () => {
    return (
        <div>
            <Navbar />
            <section className="information section">
                <div className="information-container">
                    <hr className="divider" /> {/* Top Divider */}
                    <h1 className="section-title">Information</h1>
                    <div className="info-grid">
                        {/* Airports & Transportation */}
                        <div className="info-tile">
                            <h2 className="titles">Airports & Transportation</h2>
                            <p>
                                Casa Adela and San Miguel de Allende are easily accessed by two smaller airports: Leon, Guanajuato 
                                (BJX) and Queretaro (QRO), about a 1.5-hour drive away. Mexico City’s major airport (MEX) is about 
                                3.5 hours away. Private, safe transfers from all airports can be arranged.
                            </p>
                            <p>
                                The best option is to reach out to your hotel and coordinate transportation to and from the airport with them.
                                In the event they don't have an option, you can use the below options.
                            </p>
                            <p><strong>Here are some transport options from Guanajuato airport:</strong></p>
                            <ul>
                                <li>
                                    <strong>ETISA</strong> - If you land in Leon or Queretaro<br />
                                    Contact Name: Natyelli Avalos<br />
                                    Phone: +52 442 208 99 18<br />
                                    Email: nat.avalos@etisagto.com
                                </li>
                                <li>
                                    <strong>Grupo RYO San Cristobal</strong> - If you land in Leon<br />
                                    Contact Name: Luz Gloria<br />
                                    Phone: +52 473 141 60 64<br />
                                    Email: ryosancristobal@gmail.com
                                </li>
                                <li>
                                    <a href="https://www.bajiogoshuttle.com/" target="_blank" rel="noopener noreferrer">
                                        BajioGo
                                    </a>
                                </li>
                            </ul>
                        </div>

                        {/* Hotels */}
                        <div className="info-tile">
                            <h2 className="titles">Hotels</h2>
                            <p>
                                San Miguel de Allende has many boutique hotel options! We recommend staying in the main part of the 
                                city as it is extremely walkable and convenient. Here are some hotel options:
                            </p>
                            <ul>
                                <li><a href="https://cantera1910.com/" target="_blank" rel="noopener noreferrer">Cantera 1910</a></li>
                                <li><a href="https://casa1810.com/en/casa-1810-collection-en/" target="_blank" rel="noopener noreferrer">Casa 1810</a></li>
                                <li><a href="https://www.lotel-casaarca.com/" target="_blank" rel="noopener noreferrer">Casa Arca</a></li>
                                <li><a href="https://www.casahoyos.mx/" target="_blank" rel="noopener noreferrer">Casa Hoyos</a></li>
                                <li><a href="https://www.belmond.com/es/hotels/north-america/mexico/san-miguel-de-allende/belmond-casa-de-sierra-nevada/" target="_blank" rel="noopener noreferrer">Casa de Sierra Nevada, A Belmond Hotel</a></li>
                                <li><a href="https://clandestinohotel.com/" target="_blank" rel="noopener noreferrer">Clandestino Hotel</a></li>
                                <li><a href="https://www.haciendaelsantuario.com/es/" target="_blank" rel="noopener noreferrer">Hacienda El Santuario</a></li>
                                <li><a href="https://www.hyatt.com/en-US/hotel/mexico/numu/bjxub" target="_blank" rel="noopener noreferrer">Hyatt Numu</a></li>
                                <li><a href="https://www.rosewoodhotels.com/en/san-miguel-de-allende" target="_blank" rel="noopener noreferrer">Rosewood</a></li>
                            </ul>
                        </div>

                        {/* Wedding Day Info */}
                        <div className="info-tile">
                            <h2 className="titles">Wedding Day Info</h2>
                            <p>
                                On the wedding day, transportation to and from Casa Adela will be provided. Three sprinter vans will 
                                pick guests up from San Miguel de Allende and return them after the event.
                            </p>
                            <p><strong>Attire (Colorful elegance): </strong>
                                Think classic elegance with a splash of San Miguel magic! Men, leave the tux at home. Suits are the way to go! Ladies, embrace 
                                vibrant colors, flowing fabrics, and statement accessories. Have fun with bold hues, playful prints, and refined silhouettes. Use the colorful streets and 
                                buildings of San Miguel as your inspiration!
                            </p>
                            <p><strong>Shoes & Accessories: </strong>
                                San Miguel's charming cobblestone streets call for stylish yet walkable shoes—block heels, chic flats, or dressy sandals are your best bet unless you're 
                                a pro in heels! Have fun with your look with statement earrings, a beaded clutch, or a bold lip for that effortlessly cool touch.
                            </p>
                            <p><strong>Meeting Point: Cardo Street</strong></p>
                            <div className="event-buttons">
                                <a
                                    href="https://maps.app.goo.gl/82Zmiyiuzw3Cghct5"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="button"
                                >
                                    Google Maps
                                </a>
                            </div>
                            <p>Date: November 8, 2025</p>
                            <p>Ceremony - 4:00 PM</p>
                            <p>Cocktail Hour - 4:30 PM</p>
                            <p>Reception - 5:30 PM</p>
                        </div>
                        {/* Timoteo's Taco Tour */}
                        <div className="info-tile">
                            <h2 className="titles">Timoteo's Taco Tour</h2>
                            <p>Where every bite is a fiesta and every napkin tells the tale of salsa-induced joy! 
                            Happiness isn’t bought, it’s wrapped in a warm tortilla with extra guac. If you care to 
                            explore the city through food, taco's are the way to do it:
                            </p>
                            <ul>
                                <li>
                                    <a href="https://www.google.com/maps/place/Andy's+Taco+Cart/@20.9132714,-100.7524034,16z/data=!4m10!1m3!11m2!2shK_uzLxp-qiyBXn_hLjAUd53F1tpRQ!3e3!3m5!1s0x842b51b7068e317b:0x92b865c05474885e!8m2!3d20.9166858!4d-100.7440804!16s%2Fg%2F11cmtz74xq?entry=ttu&g_ep=EgoyMDI1MDEwOC4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noopener noreferrer">
                                        <strong>Andy's Taco Cart</strong>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.google.com/maps/place/Carnitas+Apolo+XI/@20.9132714,-100.7524034,16z/data=!4m10!1m3!11m2!2shK_uzLxp-qiyBXn_hLjAUd53F1tpRQ!3e3!3m5!1s0x842b51b9ee8fcf71:0x12a7596561ffe20!8m2!3d20.9156222!4d-100.7426038!16s%2Fg%2F11gg9p62wh?entry=ttu&g_ep=EgoyMDI1MDEwOC4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noopener noreferrer">
                                        <strong>Carnitas Apolo XI</strong>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.google.com/maps/place/Don+Taco+Tequila/@20.9132714,-100.7524034,16z/data=!4m10!1m3!11m2!2shK_uzLxp-qiyBXn_hLjAUd53F1tpRQ!3e3!3m5!1s0x842b51b7970a71d1:0xc8cac15e7fce34f8!8m2!3d20.9141173!4d-100.7453244!16s%2Fg%2F1q62dmdhn?entry=ttu&g_ep=EgoyMDI1MDEwOC4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noopener noreferrer">
                                        <strong>Don Taco Tequila</strong>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.google.com/maps/place/Exquistos+Tacos+%E2%80%9CDiana%E2%80%9D/@20.905708,-100.7712521,16z/data=!4m10!1m3!11m2!2shK_uzLxp-qiyBXn_hLjAUd53F1tpRQ!3e3!3m5!1s0x842b51eaa30de72b:0xcf4480f51add6604!8m2!3d20.905708!4d-100.7617249!16s%2Fg%2F11gy30plph?entry=ttu&g_ep=EgoyMDI1MDEwOC4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noopener noreferrer">
                                        <strong>Exquistos Tacos “Diana”</strong>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.google.com/maps/place/San+Francisco/@20.9144664,-100.7519635,16z/data=!4m10!1m3!11m2!2shK_uzLxp-qiyBXn_hLjAUd53F1tpRQ!3e3!3m5!1s0x842b5160f66439df:0x2861c4757d87058f!8m2!3d20.9144664!4d-100.7424363!16s%2Fg%2F11h4gw57hb?entry=ttu&g_ep=EgoyMDI1MDEwOC4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noopener noreferrer">
                                        <strong>San Francisco</strong>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.google.com/maps/place/Tacos+Don+Felix/@20.9216058,-100.7617118,16z/data=!3m1!5s0x842b51caf50cbfe9:0xe0baa372dd7539e2!4m10!1m3!11m2!2shK_uzLxp-qiyBXn_hLjAUd53F1tpRQ!3e3!3m5!1s0x842b51caf5aa2d4b:0x39de179989b58e71!8m2!3d20.9216058!4d-100.7521846!16s%2Fg%2F11bvt4d9dd?entry=ttu&g_ep=EgoyMDI1MDEwOC4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noopener noreferrer">
                                        <strong>Tacos Don Felix</strong>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.google.com/maps/place/Tacos+Don+Tom%C3%A1s/@20.9216058,-100.7617118,16z/data=!4m10!1m3!11m2!2shK_uzLxp-qiyBXn_hLjAUd53F1tpRQ!3e3!3m5!1s0x842b51b992c08d71:0x111d44628c2ce7d6!8m2!3d20.9155949!4d-100.7423225!16s%2Fg%2F11c51tf63v?entry=ttu&g_ep=EgoyMDI1MDEwOC4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noopener noreferrer">
                                        <strong>Tacos Don Tomás</strong>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.google.com/maps/place/Tacos+%22Santos%22/@20.9155949,-100.7518497,16z/data=!3m1!5s0x842b51b2608c4889:0x7a21bb769c634e24!4m10!1m3!11m2!2shK_uzLxp-qiyBXn_hLjAUd53F1tpRQ!3e3!3m5!1s0x842b51b260ed26d3:0x421001aa2decb64c!8m2!3d20.9095671!4d-100.7518353!16s%2Fg%2F11f4w246xx?entry=ttu&g_ep=EgoyMDI1MDEwOC4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noopener noreferrer">
                                        <strong>Tacos "Santos"</strong>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.google.com/maps/place/Zempoal/@20.9095671,-100.7613625,16z/data=!4m10!1m3!11m2!2shK_uzLxp-qiyBXn_hLjAUd53F1tpRQ!3e3!3m5!1s0x842b51cb41cad08b:0x77a73650ffb7ee6e!8m2!3d20.9049366!4d-100.7488829!16s%2Fg%2F11gt_yb6bd?entry=ttu&g_ep=EgoyMDI1MDEwOC4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noopener noreferrer">
                                        <strong>Zempoal</strong>
                                    </a>
                                </li>
                            </ul>
                            <p>
                                <a href="https://maps.app.goo.gl/R9y1UuT78VL8foqA9" target="_blank" rel="noopener noreferrer">
                                    See the full Google Maps list.
                                </a>
                            </p>
                        </div>
                    </div>
                    <hr className="divider" /> {/* Bottom Divider */}
                </div>
            </section>
        </div>
    );
};

export default Information;
